import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { DateType, ReceptionItemKind, getReceptionType, ReceptionType, PaymentMethod } from 'enums/reception.enum';

const PAYMENT_LABELS = {
    'BANK': '계좌이체',
    'CARD': '카드',
    'CASH': '현금',
    'FREE': '무상',
    'ARREARS': '미수',
    'OTHER': '기타',
    '': '선택',
};

const OutBoundV = ({
    params,
    setParams,
    handleChange,
    onSearch,
    setSearch,
    onClearFilter,
    onToggleDatePickerMode,
    onHandleSearchDate,
    onOpenCreate,
    onOpenEdit,
    onOpenTripCard,
    onChangeStatus,
    onChangePaymentMethod,
    onSaveOutboundDate,
    onTodaySearch,
    handleExportExcel,
}) => {
    const { list, isLoaded, error, search } = params;

    const dateTypeOptions = [
        { value: DateType.RECEIVED, label: '접수일자' },
        { value: DateType.OUTBOUND, label: '택배출고일' }
    ];

    // 검색 매개변수 변경 핸들러
    const handleSearchChange = (field, value) => {
        const cur = PageUtil.deepCopy(params);
        cur.search[field] = value;
        setParams(cur);
    };

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>출고관리</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* 고급 검색 필터 */}
                        <SearchFilter
                            searchParams={search}
                            onSearchChange={handleSearchChange}
                            onSearch={onSearch}
                            onClearFilter={onClearFilter}
                            todayButtonName={"출고 Today"}
                            onTodaySearch={onTodaySearch}
                            showStatusFilter={false}
                            showTypeFilter={true}
                            showDateRange={true}
                            showDateType={true}
                            dateTypeOptions={dateTypeOptions}
                            placeholder="고객명, 연락처, 보일러명 등 검색"
                            onExcelDownload={handleExportExcel}
                        // additionalFilters={
                        //     <div className="row g-2">
                        //         <div className="col-12" style={{ display: 'flex', alignItems: 'center' }}>
                        //             <label className="form-label text-muted small">결제내역</label>
                        //             <div className='form-control form-control-sm'>
                        //                 <select
                        //                     className="form-select form-select-sm"
                        //                     value={search.paymentMethod || 'all'}
                        //                     onChange={(e) => handleSearchChange('paymentMethod', e.target.value)}
                        //                     style={{ width: '100%' }}
                        //                 >
                        //                     <option value="all">전체</option>
                        //                     {getPaymentMethod().map(method => (
                        //                         <option key={method.value} value={method.value}>
                        //                             {method.label}
                        //                         </option>
                        //                     ))}
                        //                 </select>
                        //             </div>
                        //         </div>
                        //         {/* <div className="col-6" style={{ display: 'flex', alignItems: 'center' }}>
                        //             <label className="form-label text-muted small">운송사</label>
                        //             <input
                        //                 type="text"
                        //                 className="form-control form-control-sm"
                        //                 placeholder="운송사명 검색"
                        //                 value={search.dlvCompany || ''}
                        //                 onChange={(e) => handleSearchChange('dlvCompany', e.target.value)}
                        //             />
                        //         </div> */}
                        //     </div>
                        // }
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">접수 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {PageUtil.formatToKRW(params.total)} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 120 }}>처리상황</th>
                                                <th>처리유형</th>
                                                <th>택배출고일</th>
                                                <th>결제내역</th>
                                                <th>견적서확인</th>
                                                <th>연락처</th>
                                                <th>고객명</th>
                                                <th>출장자</th>
                                                <th>주소</th>
                                                <th>택배출고물품</th>
                                                <th>선불/착불</th>
                                                <th>운송사</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6' } : {}}>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={row.status || ''}
                                                            onChange={(e) => onChangeStatus(row, e.target.value)}
                                                            style={{
                                                                color: row.status === 'ARREARS' ? '#dc3545' : '',
                                                                fontWeight: row.status === 'ARREARS' ? 'bold' : '',
                                                                fontSize: row.status === 'ARREARS' ? '15px' : '',
                                                            }}
                                                        >
                                                            {params.statusSet.map((s) => (
                                                                <option key={s.value} value={s.value} style={{ textAlign: 'center' }}>
                                                                    {s.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>

                                                    <td>
                                                        <span
                                                            className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE || row.type == ReceptionType.EXCHANGE ? ' bg-danger' : 'bg-info')}
                                                            style={{ fontSize: '15px', padding: '5px 10px' }} // 글자 크기와 여백 추가
                                                        >
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {(row.items?.find(p => p.courierOutboundDate)?.courierOutboundDate || '') + (row.items?.filter(p => p.courierOutboundDate)?.length > 1 ? ' 外' : '')}
                                                    </td>
                                                    <td>
                                                        {/* <span className={"badge " + (row.paymentMethod == PaymentMethod.ARREARS ? ' bg-danger' : 'bg-secondary')}>
                                                            {getPaymentMethod().find((p) => p.value === row.paymentMethod)?.label || row.paymentMethod}
                                                        </span> */}
                                                        <select
                                                            className="form-control form-control-sm"
                                                            value={row.paymentMethod || ''}
                                                            onChange={(e) => onChangePaymentMethod(row, e.target.value)}
                                                        >
                                                            {Object.entries(PAYMENT_LABELS).map(([value, label]) => (
                                                                <option key={value} value={value}>{label}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <small className="badge bg-light text-dark">
                                                            {row.estimateIssueDate ? 'Y' : 'N'}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        {row.tripCard?.agent || ''}
                                                    </td>
                                                    <td>{(row.address || '')}</td>
                                                    <td>
                                                        {/* {row.items?.map(p => p.options?.map(o => o.productName).join(', ')).join(', ')} */}
                                                        {row.outboundNote || ''}
                                                    </td>
                                                    <td>
                                                        {row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.dlvFee > 0 ? "선불" : "착불" || ''}
                                                    </td>
                                                    <td>
                                                        {row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.dlvCompany || ''}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* 페이징 */}
                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default OutBoundV;